class PurchaseOrderInfo extends HTMLElement {
  constructor() {
    super();

    const template = `
        <div>
            <div class="input-container">
                <input type="text" placeholder="optional: Purchase order number" id="purchase-order-info">
                <div class="info-logo">
                    <span class="info-icon">i</span>
                    <span class="info-message">Provide purchase order number (Optional)</span>
                </div>
            </div>
        </div>


        <style>
            /* Style for the container div */
            div {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 1rem 0;
                margin-top: 0rem;
            }

            /* Style for the select element */
            select {
                padding: 9px;
                font-size: 16px;
                border: 1px solid #ccc;
                margin-right: 10px;
                flex-basis: 35%;
                text-decoration: none;
                border-radius: var(--button-radius);
                border: var(--button-border-width) solid rgb(var(--color-button-border));
                font-family: var(--font-button-family);
            }

            /* Style for the input element */
            input[type="text"] {
                padding: 10px;
                font-size: 16px;
                border: 1px solid #ccc;
                width: 100%;
                text-decoration: none;
                border-radius: var(--button-radius);
                border: var(--button-border-width) solid rgb(var(--color-button-border));
                font-family: var(--font-button-family);
            }

            /* Optional styles for a better visual appearance */
            body {
                background-color: #f0f0f0;
                font-family: Arial, sans-serif;
            }

            h1 {
                text-align: center;
            }

            .input-container {
                position: relative;
                flex-basis: 100%;
            }

            .info-logo {
                position: absolute;
                top: 45%;
                right: 5px;
                transform: translateY(-50%);
                display: inline-block;
                width: 20px;
                height: 20px;
                background-color: #f0f0f0;
                border-radius: 50%;
                text-align: center;
                cursor: pointer;
            }

            .info-icon {
                display: block;
                font-weight: bold;
                line-height: 20px;
                color: #333;
            }

            .info-message {
                display: none;
                position: absolute;
                top: -60px;
                right: 0;
                max-width: 335px;
                min-width: 335px;
                padding: 10px;
                background-color: #f0f0f0;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                text-align: center;
                font-size: 16px;
                line-height: 1.5;
                color: #333;
            }

            .info-logo:hover .info-message {
                display: block;
            }
        </style>
      `;

    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = template;
  }

  connectedCallback() {
    const purchaseOrderInput = this.shadowRoot.getElementById("purchase-order-info");

    const handleChange = debounce(() => {
      const purchaseOrder = purchaseOrderInput.value;
      const purchaseOrderInfo = { purchaseOrder };

      if (purchaseOrder != "") {
        this.dispatchEvent(new CustomEvent("purchase-info-changed", { detail: purchaseOrderInfo }));
      }
    }, 500);

    purchaseOrderInput.addEventListener("input", handleChange);

    this.addEventListener("purchase-info-changed", (event) => {
      const { purchaseOrder } = event.detail;
      console.log(`Purchase Order Number: ${purchaseOrder}`);
      this.UpdateCart(purchaseOrder);
    });
  }

  UpdateCart = async (purchaseOrder) => {
    let formData = {
      attributes: {
        "Purchase Order": `${purchaseOrder}`,
      },
    };

    let response = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    let data = await response.json();

    console.log(data);
  };
}

customElements.define("purchase-order-info", PurchaseOrderInfo);
